require('form-serializer');
require('./blocks/cat-slider/cat-slider');
require('./blocks/digest/digest');
//require('./blocks/video-item.less');
require('./blocks/product/product');
require('./blocks/catalog.less');
require('./blocks/filter/filter');
require('./blocks/priceslider/priceslider');
require('./blocks/pagination.less');
require('./blocks/also-viewed.less');
require('./blocks/seo-catalog.less');
require('./blocks/catalog');
require('./blocks/filter-price/filter-price.less');
require('./blocks/impromptu/impromptu-one-click');
require('./blocks/catalog-banner.less');
require('./blocks/impromptu/impromptu-review');



// WEBPACK FOOTER //
// ./catalog_sections.js